import React, { useState } from 'react';
import type { MessageKindAdapter, AdapterContext } from './types';
import MessageItem from '../components/MessageItem';

/** 일반 메시지 (mail) — text body 표시 + 답장. */

const ReplyForm: React.FC<{ ctx: AdapterContext }> = ({ ctx }) => {
 const [body, setBody] = useState('');

 const onSend = async () => {
  if (!body.trim()) return;
  ctx.setBusy(true);
  try {
   await ctx.api.postMessage(ctx.conv.id, { message_type: 'text', body });
   setBody('');
   await ctx.onChange();
  } catch (e: any) {
   alert(e.message ?? '답장 실패');
  } finally {
   ctx.setBusy(false);
  }
 };

 if (ctx.conv.status !== 'open') return null;

 return (
  <div className="mb-4 border border-gray-200 p-3">
   <textarea
    rows={3}
    value={body}
    onChange={e => setBody(e.target.value)}
    placeholder="답장 내용을 입력하세요..."
    className="w-full px-3 py-2 border focus:outline-none focus:ring-2 focus:ring-blue-500 mb-2 text-sm"
    disabled={ctx.busy}
   />
   <button
    onClick={onSend}
    disabled={ctx.busy || !body.trim()}
    className="px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white text-sm disabled:opacity-50"
   >답장</button>
  </div>
 );
};

const directAdapter: MessageKindAdapter = {
 kind: 'direct',
 renderMessage: (m, ctx) => (
  <MessageItem key={m.id} message={m} viewerPeerHash={ctx.viewer.peer_hash}>
   {m.body && <div className="text-sm whitespace-pre-wrap">{m.body}</div>}
  </MessageItem>
 ),
 renderActionPanel: ctx => <ReplyForm ctx={ctx} />,
};

export default directAdapter;
